import Login from './components/login';
import LoginCreate from './components/loginCreate';
import MainComponent from './components/MainComponent';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";


function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/createlogin" element={<LoginCreate />} />
          <Route path="/admin" element={<MainComponent />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
